import { withNamespaces } from "react-i18next"
import { Card, CardBody } from "reactstrap";
import Knob from "src/modules/3rd-party-management/components/Knob";

const CoverageCard = ({
    t,
    title,
    value,
    percent,
    description
}) => {
    return (
        <Card>
            <CardBody>
                <div className="d-flex">
                    <div className="overflow-hidden" style={{ flex: "0 0 70%" }}>
                        <p
                            className="text-truncate font-size-14 mb-2"
                            style={{ textTransform: "capitalize" }}>
                            {t(title)}
                        </p>
                        <h4 className="mb-0">
                            {value.toFixed(2)} ha
                        </h4>
                    </div>

                    <div className="text-primary">
                        <Knob
                            value={percent}
                            lineCap="round"
                            height={60}
                            width={60}
                            fgColor="#545B9A"
                            thickness={0.2}
                            readOnly={true}
                        />
                    </div>
                </div>
            </CardBody>

            {description && (
                <CardBody className="border-top py-3">
                    <div className="text-truncate">
                        <span className="text-muted">
                            {t(description)}
                        </span>
                    </div>
                </CardBody>
            )}
        </Card>
    )
}

export default withNamespaces()(
    CoverageCard
);